import React from "react";
import styles from "../PolicyBuilder.module.scss";
import classNames from "classnames";

export const SectionHeader: React.FC<{
  index?: number;
  title: string;
  description: string;
  className?: string;
  /** Optional "Required"-style marker rendered next to the title. Omitted → nothing extra (DLP unaffected). */
  requiredLabel?: string;
  children?: React.ReactNode;
}> = ({ index, title, description, className, requiredLabel, children }) => {
  return (
    <div className={classNames(styles.contentHeader, className)}>
      <div className={styles.sectionTitleWrap}>
        {index && <span className={styles.sectionNumber}>{index}</span>}
        <div className={styles.sectionTitleText}>
          <div className={styles.sectionTitleRow}>
            <h3>{title}</h3>
            {requiredLabel && <span className={styles.requiredIndicator}>{requiredLabel}</span>}
          </div>
          <p>{description}</p>
        </div>
      </div>
      {children}
    </div>
  );
};
